// extracted by mini-css-extract-plugin
export default {"main_header_container_dropdown":"jV","sticky_header_title":"kV","stycky_header_title_mob":"lV","root_scroller":"mV","scroller":"nV","indicator":"oV","scrollButtons":"pV","selected":"qV","root_tab_scrollable":"rV","root_scroller_mob":"sV","scroller_mob":"tV","indicator_mob":"uV","selected_mob":"vV","root_tab_mob":"wV","root_tab_mob_scrollable":"xV","sticky_header_title_mob":"yV"};
    if(module.hot) {
      // 1713996749564
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  